import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function IdentificationSection() {
  const painPoints = ['Te enoja perder contra jugadores que sentís inferiores', 'Sabés que podrías estar en un rango más alto', 'Querés ganar más 1 vs 1', 'Te cansaste de estancarte', 'No querés ser promedio'];
  return <section className="py-20 px-4 bg-gamer-dark relative" data-id="element-133">
      <div className="max-w-4xl mx-auto" data-id="element-134">
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-135">
          {/* Visual/Graphic side (abstract representation of frustration vs goal) */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="relative hidden md:block" data-id="element-136">
            <div className="absolute inset-0 bg-gamer-red/20 blur-3xl rounded-full" data-id="element-137"></div>
            <div className="relative z-10 border border-white/10 bg-white/5 backdrop-blur-sm p-8 rounded-lg transform -rotate-3 hover:rotate-0 transition-transform duration-500" data-id="element-138">
              <h3 className="text-2xl font-orbitron font-bold text-white mb-4" data-id="element-139">
                TU SITUACIÓN ACTUAL
              </h3>
              <div className="h-2 w-full bg-gray-800 rounded-full overflow-hidden mb-2" data-id="element-140">
                <div className="h-full bg-gamer-red w-[40%]" data-id="element-141"></div>
              </div>
              <p className="text-xs text-gray-400 text-right" data-id="element-142">
                POTENCIAL DESPERDICIADO
              </p>
            </div>
          </motion.div>

          {/* Checklist side */}
          <div data-id="element-143">
            <motion.h2 initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="text-3xl font-orbitron font-bold text-white mb-8" data-id="element-144">
              ¿Te suena familiar?
            </motion.h2>

            <div className="space-y-4" data-id="element-145">
              {painPoints.map((point, index) => <motion.div key={index} initial={{
              opacity: 0,
              x: 20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.1
            }} className="flex items-start gap-3" data-id="element-146">
                  <CheckCircle2 className="w-6 h-6 text-gamer-red flex-shrink-0 mt-0.5" data-id="element-147" />
                  <p className="text-lg text-gray-300 font-inter" data-id="element-148">{point}</p>
                </motion.div>)}
            </div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.6
          }} className="mt-10" data-id="element-149">
              <p className="text-2xl md:text-3xl font-orbitron font-bold text-white border-l-4 border-gamer-yellow pl-6 py-2" data-id="element-150">
                Si competís en serio,{' '}
                <span className="text-gamer-yellow" data-id="element-151">esto es para vos.</span>
              </p>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}